import React from 'react';
import { Alert } from '@/components/ui';

interface NotesLoadErrorProps {
  error: string;
  onRetry: () => void;
}

const NotesLoadError: React.FC<NotesLoadErrorProps> = ({ error, onRetry }) => {
  return (
    <div className="mb-4 mx-4">
      <Alert
        type="danger"
        title="Failed to load notes"
        showIcon
        closable
        duration={0}
        onClose={() => window.location.reload()}
      >
        <div className="space-y-2">
          <p>{error}</p>
          <button
            onClick={onRetry}
            className="text-sm text-error hover:text-error-dark underline"
          >
            Try again
          </button>
        </div>
      </Alert>
    </div>
  );
};

export default NotesLoadError;

